import mapboxgl from "mapbox-gl";

import { ColorConstants } from "../../../../constants";

/* Brand colours for the base map, resolved once from JS constants (no DOM reads) */
const LAND = ColorConstants.GREEN_100;
const WATER = ColorConstants.SKY_BLUE_100;
const VEGETATION = ColorConstants.GREEN_200;

/* Recolours the base style's land, water and vegetation layers with brand tokens.
   Runtime overrides keep the style in-repo; a Mapbox Studio brand style can replace this later. */
export const applyBrandMapColours = (map: mapboxgl.Map): void => {
  map.getStyle()?.layers?.forEach((layer) => {
    const isWaterLayer = /water|waterway/.test(layer.id);
    const isVegetationLayer = /landcover|landuse|national-park|park|pitch|grass|wood|scrub/.test(layer.id);

    if (layer.type === "background") {
      map.setPaintProperty(layer.id, "background-color", LAND);
    } else if (layer.type === "fill" && isWaterLayer) {
      map.setPaintProperty(layer.id, "fill-color", WATER);
    } else if (layer.type === "line" && isWaterLayer) {
      map.setPaintProperty(layer.id, "line-color", WATER);
    } else if (layer.type === "fill" && isVegetationLayer) {
      map.setPaintProperty(layer.id, "fill-color", VEGETATION);
    }
  });
};
